import React, { useRef } from 'react'
import './oto1.css'
import oto1 from '../image/oto-1.png'
import oto1video from '../image/oto1-video.mp4'

import oto1addtocart from '../image/oto1-addtocart.png'
const STEPS = [
  { id: 1, label: 'Step 1 - Incomplete' },
  { id: 2, label: 'Step 2 - Customize' },
  { id: 3, label: 'Step 3 - Activate' },
]

/** Set to 2 or 3 when you wire routing / step logic. */
const CURRENT_STEP = 1

const OTO1_UNLOCK = [
  '7,000+ Ready-to-Use Leads',
  'Save Leads Into Smart Lists',
  'Add Tags (Hot, Follow-Up, Contacted)',
  'Track “Last Contacted” Automatically',
  'Organize Everything In One Dashboard',

]

const OTO1_WHY_UPGRADE = [
  'Send Outreach Messages Directly From Dashboard',
  'Set Follow-Up Reminders (Never Miss Leads)',
  'Track Lead Status (Interested / No Reply / Closed)',
  'Generate AI Outreach Messages Instantly',
  'Improve conversions with consistent follow-ups',
]

const OTO1_WHO_FOR = [
  'Freelancers & Agencies doing outreach',
  'Sales teams managing pipelines',
  'Beginners who hate manual work',
  'Anyone who wants faster conversions',
  'Users ready to scale outreach system',
]

const OTO1_PACKAGE = [
  {
    title: ' Verified Business Leads',
    text: 'All contacts verified',
    icon: 'check',
  },
  {
    title: 'Complete Business Details',
    text: 'Contact details & business info',
    icon: 'chart',
  },
  {
    title: 'CSV Export (plug into any tool)',
    text: 'Easy download format',
    icon: 'download',
  },
  {
    title: 'Regular data updates',
    text: 'Contacts refreshed',
    icon: 'sync',
  },
]

function CheckIcon() {
  return (
    <svg
      className="oto1-get__list-check"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M20 6L9 17l-5-5"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function Oto1() {
  const getCtaRef = useRef(null)

  const scrollToGetCta = () => {
    getCtaRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return (
    <div className="oto1-page">
      <div className="oto1-page-top">
        <div className="oto1-inner">
          <div className="oto1-stepper" aria-label="Setup progress">
            <div className="oto1-circles-row" role="list">
              {STEPS.map((step) => {
                const isActive = step.id === CURRENT_STEP
                return (
                  <div key={step.id} className="oto1-circle-col" role="listitem">
                    <div
                      className={`oto1-circle${isActive ? ' oto1-circle--active' : ''}`}
                      aria-current={isActive ? 'step' : undefined}
                    >
                      {step.id}
                      {isActive ? <span className="oto1-circle__pulse" aria-hidden /> : null}
                    </div>
                  </div>
                )
              })}
            </div>

            <div className="oto1-labels-row">
              {STEPS.map((step) => (
                <div key={step.id} className="oto1-label-col">
                  <div className="oto1-label-box">{step.label}</div>
                </div>
              ))}
            </div>

            <div className="oto1-status-row">
              {STEPS.map((step) => {
                const isActive = step.id === CURRENT_STEP
                return (
                  <div key={step.id} className="oto1-status-col">
                    {isActive ? (
                      <span className="oto1-status">
                        <span className="oto1-status__dot" aria-hidden />
                        In Progress
                      </span>
                    ) : (
                      <span className="oto1-status oto1-status--pending">
                        <span className="oto1-status__checkbox" aria-hidden />
                        Pending
                      </span>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>

      <section
        className="oto1-pro-offer"
        aria-labelledby="oto1-pro-heading"
      >
        <div className="oto1-pro-offer__inner">
          <h2 id="oto1-pro-heading" className="oto1-pro-offer__title">
            <span className="oto1-pro-offer__accent">Upgrade To Smart Outreach & Automation System 🚀

            </span>
          </h2>
          <p className="oto1-pro-offer__sub">
            Unlock AI-powered outreach, follow-up automation, smart lead management & ready-to-use data — all in one dashboard

          </p>

          <div className="oto1-pro-media">
            {/* <div className="oto1-pro-media__badge" aria-hidden="true">
                <span className="oto1-pro-media__badge-line">OTO 1</span>
                <span className="oto1-pro-media__badge-line">Pro Lead Booster</span>
              </div>
              <div className="oto1-pro-media__bar">
                <svg
                  className="oto1-pro-media__volume"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M11 5L6 9H3v6h3l5 4V5z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.54 8.46a5 5 0 010 7.07M17.66 6.34a8 8 0 010 11.32"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <span>CLICK PLAY TO WATCH WITH SOUND</span>
              </div> */}
            {/* <button
                type="button"
                className="oto1-pro-media__stage"
                aria-label="Play video with sound"
              >
                <img
                  className="oto1-pro-media__poster"
                  src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80"
                  alt=""
                />
                <span className="oto1-pro-media__play" aria-hidden="true">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7L8 5z" />
                  </svg>
                </span>
              </button> */}
            {/* <img
                  className="oto1-pro-media__poster"
                  src={oto1}
                  alt=""
                /> */}
            <video
              className="jv-video-frame__player"
              controls
              playsInline
              preload="metadata"
              poster={oto1}
              src={oto1video}
              title="Demo: high-converting funnel and system"
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <button type="button" className="oto1-pro-cta" onClick={scrollToGetCta}>
            <span className="oto1-pro-cta__primary">
              Click Here To Add This To Your Order »
            </span>
            <span className="oto1-pro-cta__secondary">
              Yes, Add Pro Lead Booster To My Order
            </span>
          </button>

          <div className="oto1-pro-pricing">
            <div className="oto1-pro-pricing__head">
              <p className="oto1-pro-pricing__label">One-Time Upgrade</p>
              <p className="oto1-pro-pricing__price">$20</p>
            </div>

            <ul className="oto1-pro-pricing__list">
              <li>Up to 7,000 company records</li>
              <li>Full Outreach System + Automation + AI Messaging</li>
            </ul>

            <div className="oto1-pro-pricing__meta">
              <span className="oto1-pro-pricing__tag">No Subscription</span>
              <span className="oto1-pro-pricing__tag">No Hidden Fees</span>
            </div>

            <p className="oto1-pro-pricing__note">Instant access after checkout</p>
          </div>
        </div>
      </section>

      <section
        className="oto1-get"
        aria-labelledby="oto1-get-heading"
      >
        <div className="oto1-get__inner">
          <h2 id="oto1-get-heading" className="oto1-get__title">
            <span className="oto1-get__yellow">Everything You Need To Find, Manage & Close Leads Faster
            </span>
          </h2>
          <p className="oto1-get__lead">
            Upgrade to <strong>Pro Lead Booster</strong> and unlock serious
            lead-gen power
          </p>

          <div className="oto1-get-highlight">
            <div className="oto1-get-highlight__row">
              <div className="oto1-get-highlight__main">
                <div className="oto1-get-highlight__icon" aria-hidden>
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M16 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zM8 11c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3z"
                      fill="#63b3ed"
                    />
                    <path
                      d="M8 13c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                      fill="#63b3ed"
                    />
                    <path
                      d="M19 8v4M17 10h4"
                      stroke="#90cdf4"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
                <div>
                  <p className="oto1-get-highlight__headline">
                    Get 7,000+ Verified Leads + Smart Outreach System

                  </p>
                  <p className="oto1-get-highlight__sub">
                    Start with a powerful lead base and combine it with your Leadszora system for faster campaigns
                  </p>
                </div>
              </div>
              <div className="oto1-get-highlight__pills">
                <span className="oto1-get-pill oto1-get-pill--blue">
                  Verified
                </span>
                <span className="oto1-get-pill oto1-get-pill--purple">
                  Ready-to-Use
                </span>
                <span className="oto1-get-pill oto1-get-pill--green">
                  With contact details
                </span>
              </div>
            </div>
            <div className="oto1-get-highlight__stats">
              <div className="oto1-get-stat">
                {/* <span className="oto1-get-stat__num">7K+</span> */}
                <span className="oto1-get-stat__lbl">7,000+ Ready Leads</span>
              </div>
              <div className="oto1-get-stat">
                {/* <span className="oto1-get-stat__num">95%+</span> */}
                <span className="oto1-get-stat__lbl">AI Outreach + Follow-Ups</span>
              </div>
              <div className="oto1-get-stat">
                {/* <span className="oto1-get-stat__num">CSV</span> */}
                <span className="oto1-get-stat__lbl">Lists, Tags & Pipeline Tracking</span>
              </div>
            </div>
          </div>

          <div className="oto1-get-columns">
            <article className="oto1-get-card">
              <h3 className="oto1-get-card__title">
                <span className="oto1-get-card__icon oto1-get-card__icon--diamond" aria-hidden>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l8 10-8 10-8-10 8-10z" />
                  </svg>
                </span>
                What You Unlock
              </h3>
              <ul className="oto1-get-list">
                {OTO1_UNLOCK.map((t) => (
                  <li key={t}>
                    <CheckIcon />
                    {t}
                  </li>
                ))}
              </ul>
            </article>
            <article className="oto1-get-card">
              <h3 className="oto1-get-card__title">
                <span className="oto1-get-card__icon oto1-get-card__icon--chart" aria-hidden>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M4 19h16v2H4v-2zM6 15h2v4H6v-4zm4-6h2v10h-2V9zm4-4h2v14h-2V5zm4 3h2v11h-2V8z" />
                  </svg>
                </span>
                Why Upgrade?
              </h3>
              <ul className="oto1-get-list">
                {OTO1_WHY_UPGRADE.map((t) => (
                  <li key={t}>
                    <CheckIcon />
                    {t}
                  </li>
                ))}
              </ul>
            </article>
            <article className="oto1-get-card">
              <h3 className="oto1-get-card__title">
                <span className="oto1-get-card__icon oto1-get-card__icon--person" aria-hidden>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                </span>
                Who Is This For?
              </h3>
              <ul className="oto1-get-list">
                {OTO1_WHO_FOR.map((t) => (
                  <li key={t}>
                    <CheckIcon />
                    {t}
                  </li>
                ))}
              </ul>
            </article>
          </div>

          <div className="oto1-get-package">
            <h3 className="oto1-get-package__title">
              <span className="oto1-get-package__title-icon" aria-hidden>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </span>
              Your 7,000+ Lead Package Includes:
            </h3>
            <div className="oto1-get-package__grid">
              {OTO1_PACKAGE.map((item) => (
                <div key={item.title} className="oto1-get-mini">
                  <div className="oto1-get-mini__icon" aria-hidden>
                    {item.icon === 'check' && (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M20 6L9 17l-5-5"
                          stroke="#48bb78"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                    {item.icon === 'chart' && (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="#63b3ed">
                        <path d="M4 19h16v2H4v-2zM8 13h2v6H8v-6zm5-4h2v10h-2V9zm5-3h2v13h-2V6z" />
                      </svg>
                    )}
                    {item.icon === 'download' && (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12 3v12m0 0l4-4m-4 4L8 11M5 21h14"
                          stroke="#ecc94b"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                    {item.icon === 'sync' && (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M4 9a8 8 0 0113.657-5.657M20 15a8 8 0 01-13.657 5.657M4 9v4h4M20 15v-4h-4"
                          stroke="#48bb78"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </div>
                  <p className="oto1-get-mini__title">{item.title}</p>
                  <p className="oto1-get-mini__text">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="oto1-get-cta" id="oto1-get-cta" ref={getCtaRef}>
            <div className="oto1-get-cta__cart-btn">
              <a
                className="oto1-get-cta__cart-btn-img"
                href="https://warriorplus.com/o2/buy/sd90jm/m3j8tm/jw9s33"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={oto1addtocart} alt="Add to Cart" />
              </a>
            </div>
          </div>
            <p className="oto1-pricing-pro__disclaimer">
            <em>WarriorPlus is used to help manage the sale of products on this site. While WarriorPlus helps facilitate the sale, all payments are made directly to the product vendor and NOT WarriorPlus. Thus, all product questions, support inquiries and/or refund requests must be sent to the vendor. WarriorPlus's role should not be construed as an endorsement, approval or review of these products or any claim, statement or opinion used in the marketing of these products.</em>
            </p>
            <p className="oto1-get-cta__foot">
              <span className="oto1-get__yellow">Get Full Outreach System + 7,000+ Leads + AI Messaging
              </span>
            </p>
            <p className="oto1-get-cta__instant">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
              </svg>
              Instant Access • Complete Contact Data
            </p>
        </div>
      </section>

      <section
        className="oto1-urgent"
        aria-labelledby="oto1-urgent-headline"
      >
        <div className="oto1-urgent__inner">
          <p className="oto1-urgent__updated">Updated 3 minutes ago</p>

          <div
            className="oto1-urgent__track"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={80}
            aria-label="Offer availability"
          >
            <div className="oto1-urgent__fill">
              <span className="oto1-urgent__fill-text">
                This Upgrade Is Only Available On This Page — Don’t Miss It
              </span>
            </div>
          </div>

          <div className="oto1-urgent__headline-box" id="oto1-urgent-headline">
            Want More Replies, More Leads & More Clients — Without Extra Effort?

          </div>

          <p className="oto1-urgent__bold">
            One-time upgrade available during checkout.
          </p>
          <p className="oto1-urgent__bold">No subscription required.</p>

          <p className="oto1-urgent__fine">
            Instead of spending hours finding leads manually, Stop collecting leads manually — start managing, contacting & closing them with a complete system
            and focus on outreach and results.
          </p>
          <p className="oto1-urgent__fine">
            This upgrade helps you move faster, stay consistent, and get more done in less time.
          </p>

          <button type="button" className="oto1-urgent__cta" onClick={scrollToGetCta}>
            <span className="oto1-urgent__cta-row">
              {/* <svg
                className="oto1-urgent__cta-cart"
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.15.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
              </svg> */}
              <span className="oto1-urgent__cta-main">
                Click Here To Add This To Your Order NOW!
              </span>
            </span>
            <span className="oto1-urgent__cta-sub">
              Yes - I Want To Enhance Your Lead Research Capabilities
            </span>
          </button>


        </div>
      </section>
      <footer className="oto2-site-footer">
        <div className="oto2-site-footer__inner">
          <p className="oto2-site-footer__copy">
            © {new Date().getFullYear()} Leadszora. All Rights Reserved.
          </p>
          <nav className="oto2-site-footer__nav" aria-label="Footer">
            <a href="/2.0privacy-policy">Privacy Policy</a>
            <span className="oto2-site-footer__sep" aria-hidden>
              |
            </span>
            <a href="/2.0Terms-of-Service">Terms &amp; Conditions</a>
            <span className="oto2-site-footer__sep" aria-hidden>
              |
            </span>
            <a href="/2.0Earning-Disclaimer">Earning Disclaimer</a>
            <span className="oto2-site-footer__sep" aria-hidden>
              |
            </span>
            <a href="/2.0Contact-Us">Contact Us</a>
          </nav>
        </div>
      </footer>
    </div>
  )
}

export default Oto1
